var _components;

import Icon from '../icon';
import create from '../utils/create-basic';
import { getChannelByTheme } from '@tujia/fe-css/lib/jsUtil/themeHelper';
import ctripMayiLoading from './ctripMayiLoading';
export default create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      class: _vm.b([_vm.type])
    }, [_vm.type === 'tjloading' && !_vm.isShowCtripOrMayiLoading ? _c('div', {
      class: _vm.b('tjloading')
    }, [_c('div', {
      staticClass: "loadingImage"
    }), _c('div', {
      staticClass: "bgImage"
    })]) : _vm.type === 'tjloading' && _vm.isShowCtripOrMayiLoading ? _c('ctripMayiLoading') : _vm.type === 'themeloading' ? _c('div', {
      class: _vm.b('loading')
    }, [_c('div', {
      staticClass: "theme-loading",
      style: _vm.iconStyle
    })]) : _vm.type === 'pointloading' ? _c('div', {
      class: _vm.b('pointloading')
    }, [_c('svg', {
      staticClass: "spinner",
      style: _vm.pointStyle,
      attrs: {
        "viewBox": "0 0 64 64"
      }
    }, [_c('g', [_c('circle', {
      attrs: {
        "cx": "16",
        "cy": "32",
        "stroke-width": "0",
        "r": "3"
      }
    }, [_c('animate', {
      attrs: {
        "attributeName": "fill-opacity",
        "dur": "1200ms",
        "values": ".5;.6;.8;1;.8;.6;.5;.5",
        "repeatCount": "indefinite"
      }
    }), _c('animate', {
      attrs: {
        "attributeName": "r",
        "dur": "1200ms",
        "values": "3;3;3.5;3;3;3.5;3;3",
        "repeatCount": "indefinite"
      }
    })]), _c('circle', {
      attrs: {
        "cx": "28",
        "cy": "32",
        "stroke-width": "0",
        "r": "3.09351"
      }
    }, [_c('animate', {
      attrs: {
        "attributeName": "fill-opacity",
        "dur": "1200ms",
        "values": ".5;.5;.6;.8;1;.8;.6;.5",
        "repeatCount": "indefinite"
      }
    }), _c('animate', {
      attrs: {
        "attributeName": "r",
        "dur": "1200ms",
        "values": "3;3.5;3;3;3.5;3;3;3.5",
        "repeatCount": "indefinite"
      }
    })]), _c('circle', {
      attrs: {
        "cx": "40",
        "cy": "32",
        "stroke-width": "0",
        "r": "4.09351"
      }
    }, [_c('animate', {
      attrs: {
        "attributeName": "fill-opacity",
        "dur": "1200ms",
        "values": ".6;.5;.5;.6;.8;1;.8;.6",
        "repeatCount": "indefinite"
      }
    }), _c('animate', {
      attrs: {
        "attributeName": "r",
        "dur": "1200ms",
        "values": "3.5;3;3;3.5;3;3;3.5;3",
        "repeatCount": "indefinite"
      }
    })])])])]) : _c('div', {
      class: _vm.b('loading')
    }, [_c('div', {
      staticClass: "defalt-loading",
      style: _vm.iconStyle
    })])], 1);
  },
  name: 'loading',
  props: {
    size: {
      type: String,
      default: '16px'
    },
    type: {
      type: String,
      default: 'loading'
    },
    color: {
      type: String,
      default: '#ff9645'
    }
  },
  components: (_components = {}, _components[Icon.name] = Icon, _components.ctripMayiLoading = ctripMayiLoading, _components),
  computed: {
    style: function style() {
      return {
        width: this.size,
        height: this.size
      };
    },
    iconStyle: function iconStyle() {
      return {
        backgroundSize: this.size + " " + this.size,
        width: this.size,
        height: this.size
      };
    },
    pointStyle: function pointStyle() {
      return {
        fill: this.color,
        width: this.size
      };
    },

    /**
     * 是否展示ctrip或蚂蚁loading
     */
    isShowCtripOrMayiLoading: function isShowCtripOrMayiLoading() {
      return getChannelByTheme() === 'ctrip' || getChannelByTheme() === 'mayi';
    }
  }
});